import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, MessageCircle, Instagram } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

const LOGO_PUTIH = "https://yayasanwakaftozan.org/res/logo-footer-putih.png";

const footerLinks = [
  { name: "Beranda",               path: "/" },
  { name: "Tentang Kami",           path: "/tentang-kami" },
  { name: "Galeri Foto",            path: "/galeri-foto" },
  { name: "Jurnal",                 path: "/jurnal" },
  { name: "Artikel",                path: "/artikel" },
  { name: "Informasi Pendaftaran",  path: "/informasi-pendaftaran" },
  { name: "Fasilitas Sekolah",      path: "/fasilitas-sekolah" },
];

export default function Footer() {
  const { waUrl } = useSettings();
  return (
    <footer data-testid="footer" style={{ backgroundColor: "#198530" }} className="text-white">
      <div className="max-w-6xl mx-auto px-4 py-7 sm:py-10 grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
        {/* Brand */}
        <div>
          <div className="mb-3">
            <img
              src={LOGO_PUTIH}
              alt="Logo Yayasan Wakaf Tongku Azhar Nahdliyyin"
              className="h-16 sm:h-20 w-auto"
              style={{ mixBlendMode: "screen" }}
            />
          </div>
          <p className="text-xs sm:text-sm leading-relaxed" style={{ color: "#bbf7d0" }}>
            Lembaga pendidikan, dakwah, dan sosial Islam berlandaskan
            Ahlusunnah wal Jamaah di Namorambe, Medan.
          </p>
          <p className="mt-2 text-xs font-semibold italic" style={{ color: "#d4af37", fontFamily: "'Amiri', serif" }}>
            Motto: Zikir, Fikir, Amal Sholeh, dan Barokah
          </p>
        </div>

        {/* Navigation Links 
        <div>
          <h4 className="font-bold mb-3 text-sm" style={{ color: "#d4af37" }}>Navigasi</h4>
          <ul className="space-y-1.5">
            {footerLinks.map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className="text-xs sm:text-sm transition-colors hover:text-white"
                  style={{ color: "#bbf7d0" }}
                  data-testid={`footer-link-${link.name.toLowerCase().replace(/\s/g, "-")}`}
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        */}
        {/* Contact */}
        <div>
          <h4 className="font-bold mb-3 text-sm" style={{ color: "#d4af37" }}>Kontak &amp; Sosial Media</h4>
          <div className="space-y-2">
            <div className="flex items-start gap-2">
              <MapPin size={14} className="flex-shrink-0 mt-0.5" style={{ color: "#d4af37" }} />
              <span className="text-xs sm:text-sm" style={{ color: "#bbf7d0" }}>
                Desa Sudirejo, Jl. Suka Tanam, Gang. Mantep 1, No. 07 Namorambe, Medan
              </span>
            </div>
            <div className="flex items-center gap-2">
              <Phone size={14} className="flex-shrink-0" style={{ color: "#d4af37" }} />
              <span className="text-xs sm:text-sm" style={{ color: "#bbf7d0" }}>0812-1421-6628 (Kantor)</span>
            </div>
            <div className="flex items-center gap-2">
              <Phone size={14} className="flex-shrink-0" style={{ color: "#d4af37" }} />
              <span className="text-xs sm:text-sm" style={{ color: "#bbf7d0" }}>0812-1245-5254 (Pendaftaran)</span>
            </div>

            {/* Instagram Links */}
            <div className="flex items-center gap-2">
              <Instagram size={14} className="flex-shrink-0" style={{ color: "#d4af37" }} />
              <a
                href="https://instagram.com/ra.al.armi"
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs sm:text-sm hover:text-white transition-colors"
                style={{ color: "#bbf7d0" }}
              >
                @ra.al.armi (Raudhatul Athfal)
              </a>
            </div>
            <div className="flex items-center gap-2">
              <Instagram size={14} className="flex-shrink-0" style={{ color: "#d4af37" }} />
              <a
                href="https://instagram.com/alarmimis"
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs sm:text-sm hover:text-white transition-colors"
                style={{ color: "#bbf7d0" }}
              >
                @alarmimis (Madrasah Ibtidaiyah)
              </a>
            </div>
          </div>

          <a
            href={waUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-wa-button"
            className="mt-4 inline-flex items-center gap-2 text-white text-xs font-semibold px-4 py-2 rounded-xl transition-colors"
            style={{ backgroundColor: "#198530" }}
          >
            <MessageCircle size={14} />
            Hubungi via WhatsApp
          </a>
        </div>
      </div>

      <div className="border-t py-4 text-center" style={{ borderColor: "#166534" }}>
        <p className="text-xs" style={{ color: "#86efac" }}>
          &copy; 2026 PT. Cloud Rise Technology. All rights reserved.
        </p>
        <p className="text-xs mt-0.5" style={{ color: "#6b7280" }}>
          Madrasah Ibtidaiyah Al-Armi &mdash; Namorambe, Medan
        </p> 
      </div>
    </footer>
  );
}
